import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { FieldTypography } from './FieldTypography';
export const FieldLabel = (_ref) => {
  let {
    classes = {},
    i,
    children,
    label
  } = _ref,
      props = _objectWithoutProperties(_ref, ["classes", "i", "children", "label"]);

  return /*#__PURE__*/React.createElement(FieldTypography, _extends({
    className: classes.label
  }, props), i ? ' ' : '', label || children, !i ? ': ' : ' ');
};